import billingCategoryEditComponent from './billing_category.edit.component';

let billingCategoryEditModule = angular.module('billingCategoryEdit', [])

    .component('billingCategoryEdit', billingCategoryEditComponent)

    .name;

export default billingCategoryEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/edit/index.js